import { Component } from "react";
import { Card, Form, Button, Row, Col } from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { withRouter } from '../../common/with-router';
import { IMaskInput } from "react-imask";
import { FaArrowLeft } from "react-icons/fa";
import { estados } from '../../common/utils';

class CentrosReferenciaEdit extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.state = {
            centro_id: '',
            nome: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cep: '',
            uf: '',
            cidade: '',
            responsavel_recebimento: '',
            telefone: '',
            // Helpers para mensagens de erro
            nomeHelper: '',
            enderecoHelper: '',
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cepHelper: '',
            ufHelper: '',
            cidadeHelper: '',
            responsavelHelper: '',
            telefoneHelper: '',
            // Estado geral
            titulo_pagina: '',
            loading: false,
            erroLoadRegistro: '',
        };
    }

    componentDidMount() {
        this.carregarDadosCentro();
    }

    carregarDadosCentro = () => {
        const id = this.props.router.params.id;

        if (id) {
            this.setState({
                centro_id: id,
                loading: true,
                erroLoadRegistro: '',
            });

            api.get(`/centros_referencia/${id}/`)
                .then(response => {
                    const dados = response.data;
                    const dadosTratados = this.tratarNulos(dados);

                    this.setState({
                        erroLoadRegistro: '',
                        nome: dadosTratados.nome,
                        endereco: dadosTratados.endereco,
                        numero: dadosTratados.numero,
                        complemento: dadosTratados.complemento,
                        bairro: dadosTratados.bairro,
                        cep: dadosTratados.cep,
                        uf: dadosTratados.uf,
                        cidade: dadosTratados.cidade,
                        responsavel_recebimento: dadosTratados.responsavel_recebimento,
                        telefone: dadosTratados.telefone,
                        loading: false,
                        titulo_pagina: 'Editando Centro: ' + dadosTratados.nome,
                    });
                })
                .catch(error => {
                    let erro_msg = 'Erro ao consultar centro de referência, tente novamente';

                    if (error.response?.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    } else if (error.response?.status === 404) {
                        erro_msg = 'Centro de referência não encontrado';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                        loading: false,
                    });
                });
        } else {
            this.setState({
                centro_id: '',
                titulo_pagina: 'Adicionar Centro de Referência',
                loading: false,
                erroLoadRegistro: '',
            });
        }
    };

    tratarNulos = (obj) => {
        const novoObjeto = {};
        for (let key in obj) {
            novoObjeto[key] = (obj[key] === null || obj[key] === "null") ? "" : obj[key];
        }
        return novoObjeto;
    };

    enviaRegistro = (e) => {
        e.preventDefault();

        // Limpar helpers de erro
        this.setState({
            nomeHelper: '',
            enderecoHelper: '',
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cepHelper: '',
            ufHelper: '',
            cidadeHelper: '',
            responsavelHelper: '',
            telefoneHelper: '',
        });

        const url = this.state.centro_id 
            ? `/centros_referencia/${this.state.centro_id}/` 
            : '/centros_referencia/';
        const metodo = this.state.centro_id ? 'put' : 'post';

        const dados = {
            nome: this.state.nome,
            endereco: this.state.endereco || '',
            numero: this.state.numero || '',
            complemento: this.state.complemento || '',
            bairro: this.state.bairro || '',
            cep: this.state.cep || '',
            uf: this.state.uf || '',
            cidade: this.state.cidade || '',
            responsavel_recebimento: this.state.responsavel_recebimento || '',
            telefone: this.state.telefone || '',
        };

        this.setState({ loading: true });

        api({
            method: metodo,
            url: url,
            data: dados,
        })
            .then(response => {
                const MySwal = withReactContent(Swal);
                const textSwal = this.state.centro_id 
                    ? 'Centro de referência atualizado com sucesso' 
                    : 'Centro de referência cadastrado com sucesso';

                MySwal.fire({
                    title: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                });

                this.setState({ loading: false });
                this.props.router.navigate("/centros-referencia");
            })
            .catch(error => {
                let erro_msg = "Erro ao realizar o cadastro:<br />";

                if (error.response?.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response?.status === 400) {
                    const responseData = error.response.data;
                    const campos = responseData.erros ? responseData.erros : responseData;

                    for (let key in campos) {
                        const value = campos[key];
                        erro_msg += "<br />" + key + ": " + value;

                        if (key === 'nome') {
                            this.setState({ nomeHelper: value });
                        }
                        if (key === 'endereco') {
                            this.setState({ enderecoHelper: value });
                        }
                        if (key === 'numero') {
                            this.setState({ numeroHelper: value });
                        }
                        if (key === 'complemento') {
                            this.setState({ complementoHelper: value });
                        }
                        if (key === 'bairro') {
                            this.setState({ bairroHelper: value });
                        }
                        if (key === 'cep') {
                            this.setState({ cepHelper: value });
                        }
                        if (key === 'uf') {
                            this.setState({ ufHelper: value });
                        }
                        if (key === 'cidade') {
                            this.setState({ cidadeHelper: value });
                        }
                        if (key === 'responsavel_recebimento') {
                            this.setState({ responsavelHelper: value });
                        }
                        if (key === 'telefone') {
                            this.setState({ telefoneHelper: value });
                        }
                    }
                }

                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: "Atenção!",
                    html: erro_msg,
                });

                this.setState({ loading: false });
            });
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleMaskAccept = (fieldName) => (value) => {
        this.setState({ [fieldName]: value });
    };

    render() {
        if (this.state.erroLoadRegistro) {
            return (
                <div>
                    <Row className="align-items-center">
                        <Col sm={12}>
                            <h5 className="page-title">{this.state.erroLoadRegistro}</h5>
                        </Col>
                    </Row>
                </div>
            );
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="light" href="/centros-referencia" size="sm">
                            <FaArrowLeft /> Voltar
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Form onSubmit={this.enviaRegistro}>
                            <Row>
                                <Col sm={12} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="nome" 
                                            required 
                                            placeholder="Nome do centro de referência" 
                                            value={this.state.nome} 
                                            onChange={this.handleChange} 
                                        />
                                        <Form.Text className="text-danger">{this.state.nomeHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>CEP</Form.Label>
                                        <Form.Control 
                                            as={IMaskInput} 
                                            unmask="typed" 
                                            mask="00000-000" 
                                            placeholder="CEP" 
                                            name="cep" 
                                            value={this.state.cep} 
                                            onAccept={this.handleMaskAccept('cep')} 
                                        />
                                        <Form.Text className="text-danger">{this.state.cepHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={7} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Endereço</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="endereco" 
                                            placeholder="Endereço" 
                                            value={this.state.endereco} 
                                            onChange={this.handleChange} 
                                        />
                                        <Form.Text className="text-danger">{this.state.enderecoHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Número</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="numero" 
                                            placeholder="Nº" 
                                            value={this.state.numero} 
                                            onChange={this.handleChange} 
                                        />
                                        <Form.Text className="text-danger">{this.state.numeroHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Complemento</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="complemento" 
                                            placeholder="Complemento" 
                                            value={this.state.complemento} 
                                            onChange={this.handleChange} 
                                        />
                                        <Form.Text className="text-danger">{this.state.complementoHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Bairro</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="bairro" 
                                            placeholder="Bairro" 
                                            value={this.state.bairro} 
                                            onChange={this.handleChange} 
                                        />
                                        <Form.Text className="text-danger">{this.state.bairroHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={4} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cidade</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="cidade" 
                                            placeholder="Cidade" 
                                            value={this.state.cidade} 
                                            onChange={this.handleChange} 
                                        />
                                        <Form.Text className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={2} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>UF</Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="uf" 
                                            value={this.state.uf} 
                                            onChange={this.handleChange}
                                        >
                                            <option value="">Selecione</option>
                                            {Object.entries(estados).map(([sigla, nome]) => (
                                                <option key={sigla} value={sigla}>{sigla} - {nome}</option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="text-danger">{this.state.ufHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={5} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Responsável pelo Recebimento</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="responsavel_recebimento" 
                                            placeholder="Nome do responsável" 
                                            value={this.state.responsavel_recebimento} 
                                            onChange={this.handleChange} 
                                        />
                                        <Form.Text className="text-danger">{this.state.responsavelHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={5} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Telefone</Form.Label>
                                        <Form.Control 
                                            as={IMaskInput} 
                                            unmask="typed" 
                                            mask="(00) 00000-0000" 
                                            placeholder="Telefone" 
                                            name="telefone" 
                                            value={this.state.telefone} 
                                            onAccept={this.handleMaskAccept('telefone')} 
                                        />
                                        <Form.Text className="text-danger">{this.state.telefoneHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={12} className="text-end">
                                    <Button type="submit" variant="secondary" disabled={this.state.loading}>
                                        {this.state.loading ? 'Salvando...' : 'Salvar'}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default withRouter(CentrosReferenciaEdit);
